import { Platform } from 'react-native';

export function buildMapsUrl(
  latitude?: number,
  longitude?: number,
): string | null {
  if (!latitude || !longitude) return null;

  if (Platform.OS === 'ios') {
    return `https://maps.apple.com/?q=${latitude},${longitude}`;
  }
  return `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
}
